import { format } from 'date-fns';

/**
 * Formats a date in UK format: DD-MM-YYYY
 * @param date - Date object or string to format
 * @returns Formatted date string in DD-MM-YYYY format
 */
export function formatUKDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'dd-MM-yyyy');
}

/**
 * Formats a date for database storage (ISO format but still useful helper)
 * @param date - Date object to format
 * @returns Formatted date string in yyyy-MM-dd format for database
 */
export function formatDBDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

/**
 * Formats a date for display with time in UK format
 * @param date - Date object or string to format
 * @returns Formatted date and time string
 */
export function formatUKDateTime(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'dd-MM-yyyy HH:mm');
}

/**
 * Formats a date for display in long format
 * @param date - Date object or string to format
 * @returns Formatted date string like "1st January 2025"
 */
export function formatUKLongDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'do MMMM yyyy');
}
